import './styles.scss';
import React, {Dispatch} from "react";

/* Types, Constants, Utils */
import * as Constants from "../../../constants";
import {IFileAttributes} from "../../../types/document";

/* Components */
import ViewerDocument from "../../../components/viewer/viewer-document";
import ViewerToolbar from "../../../components/viewer/viewer-toolbar";
import ViewerMetadata from "../../../components/viewer/viewer-metadata";
import ViewerRecords from "../../../components/viewer/viewer-records";
import ViewerCite from "../../../components/viewer/viewer-cite";
import ViewerTagsNotes from "../../../components/viewer/viewer-save";
import ViewerDownload from "../../../components/viewer/viewer-download";
import ViewerShare from "../../../components/viewer/viewer-share";
import ViewerTools from "../../../components/viewer/viewer-tools";
import {IViewerState} from "../../../types/redux/viewer";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../redux";
import {setRecordTool} from "../../../redux/slices/viewer-slice";
import {AnyAction} from "@reduxjs/toolkit";
import usePlatform from "../../../hooks/usePlatform";
import {useSearchParams} from "react-router-dom";

interface IProps {
  fileAttributes: IFileAttributes;
}

const ViewerMobile = (props: IProps):JSX.Element => {
  const {
    fileAttributes,
  } = props;

  /* redux */
  const activeRecordTool: string = useSelector<RootState, IViewerState>(state => state.viewer).recordTool;
  const viewerState: IViewerState = useSelector<RootState, IViewerState>(state => state.viewer);
  const dispatch:Dispatch<AnyAction> = useDispatch();

  /* state */
  const [searchParams, setSearchParams] = useSearchParams();

  /* hooks */
  const platform = usePlatform();

  const toolPanel = ():JSX.Element => {
    let tool: JSX.Element;
    switch (activeRecordTool) {

      case Constants.METADATA:
        tool = <ViewerMetadata/>
        break;

      case Constants.SEARCH_RESULTS:
      case Constants.BROWSE:
      case Constants.BATES:
      case Constants.MORE_LIKE_THIS:
      case Constants.POSSIBLE_DUPLICATES:
        tool = <ViewerRecords/>
        break;

      case Constants.CITE:
        tool = <ViewerCite/>
        break;

      case Constants.TAGS_NOTES:
        tool = <ViewerTagsNotes/>
        break;

      case Constants.DOWNLOAD:
        tool = <ViewerDownload/>
        break;

      case Constants.SHARE:
        tool = <ViewerShare/>
        break;

      case Constants.DOCUMENT:
        tool = <>
          <ViewerToolbar
            fileType={viewerState.contentView ||fileAttributes?.type}
            activeRecordTool={activeRecordTool}
          />
          <ViewerDocument
            fileAttributes={fileAttributes}/>
        </>
        break;

      default:
        tool = <></>;
    }
    return tool;
  }

  const setActiveTool = (recordTool: string | null): void => {
    searchParams.set(Constants.RECORD_TOOL_PARAM, recordTool);
    setSearchParams(searchParams);
    dispatch(setRecordTool(recordTool));
  }

  return (
    <>
    {platform.isMobile ?
    <div className={'viewer-mobile'}>
      {!activeRecordTool && <ViewerTools
          fileType={fileAttributes?.type}
          setActiveTool={setActiveTool}
          />}

      {(activeRecordTool !== null) && toolPanel()}
    </div> : <></>}
    </>
  )
}

export default ViewerMobile;
